import React, { useEffect, useRef } from "react";

const LIVE_URL = "https://armstrong-estimator.emergent.host";

// Shows a warning only when the app is opened on the old preview/test copy,
// so the user is never stuck entering data into the wrong environment.
// It pushes the page down (body padding) instead of overlaying the nav.
export const TestEnvBanner = () => {
  const ref = useRef(null);
  const host = typeof window !== "undefined" ? window.location.hostname : "";
  const isTestCopy = host.includes("preview.emergentagent.com");

  useEffect(() => {
    if (!isTestCopy) return undefined;
    const apply = () => {
      document.body.style.paddingTop = `${ref.current ? ref.current.offsetHeight : 0}px`;
    };
    apply();
    window.addEventListener("resize", apply);
    const ro = typeof ResizeObserver !== "undefined" ? new ResizeObserver(apply) : null;
    if (ro && ref.current) ro.observe(ref.current);
    return () => {
      window.removeEventListener("resize", apply);
      if (ro) ro.disconnect();
      document.body.style.paddingTop = "";
    };
  }, [isTestCopy]);

  if (!isTestCopy) return null;

  return (
    <div
      ref={ref}
      data-testid="test-env-banner"
      style={{
        position: "fixed",
        top: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        background: "#dc2626",
        color: "#fff",
        padding: "6px 12px",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 10,
        flexWrap: "wrap",
        fontSize: 13,
        fontWeight: 600,
        lineHeight: 1.3,
        boxShadow: "0 2px 8px rgba(0,0,0,0.25)",
      }}
    >
      <span data-testid="test-env-banner-text">
        ⚠️ TEST version — your live app is at armstrong-estimator.emergent.host
      </span>
      <a
        href={LIVE_URL}
        data-testid="test-env-banner-open-live"
        style={{
          background: "#fff",
          color: "#dc2626",
          padding: "3px 12px",
          borderRadius: 9999,
          fontWeight: 700,
          textDecoration: "none",
          whiteSpace: "nowrap",
        }}
      >
        Open live app →
      </a>
    </div>
  );
};

export default TestEnvBanner;
